import React, { Component } from "react";
import Bannerimg from "../images/locator-banner.webp";
import Bannerimg1 from "../images/locator-banner1.webp";
import Bannerimg2 from "../images/locator-banner2.webp";
import BannerimgMob from "../images/slider-banner1.jpg";
import BannerimgMob1 from "../images/slider-banner2.jpg";
import BannerimgMob2 from "../images/slider-banner3.jpg";
// import downloadimg from "../images/download.png";
import Slider from "react-slick";

class Banner extends Component {
 
  render() {
    var settingsHomeBanner = {
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      autoplay: true,   
    };
    return (
      <div className="col-md-12 banner-main">
        <div className="loader"></div>
        <div className="banner-web-show">
        <Slider {...settingsHomeBanner}>
        <a href="https://maximus.axis.bank.in/external/customer/login/?product=credit_card&channelName=VENDOR&channelCode=WEBSITE&utm_content=branchbanking&utm_campaign=neo&cta=branch-banking-neo-banner-first" target="_blank" rel="noopener noreferrer">
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_701afd26-3fce-40c8-85d0-c98520978050.webp"} alt="AxisBank Banner" className="bannerImages d-none d-md-block" width="1349" height="211" title="Axis Bank NEO Credit Card"/>
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_67997170-9b83-4759-a6ac-eaadefccc098.webp"} alt="AxisBank Banner" className="bannerImages d-block d-md-none" width="480" height="480"/>
          </a>
          <a href="https://supernova.axis.bank.in/current-account?cta=branch-locator-sole-prop-banner" target="_blank" rel="noopener noreferrer">
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_3bc91838-44cf-456e-803d-265d27edca16.webp"} alt="AxisBank Banner" className="bannerImages d-none d-md-block" width="1349" height="211" title="Digital Current Account"/>
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_3ecc9509-0405-4c11-9797-54c930956fb3.webp"} alt="AxisBank Banner" className="bannerImages d-block d-md-none" width="480" height="480"/>
          </a>
          {/* <a href="https://maximus.axis.bank.in/external/customer/login?product=credit_card&channelName=VENDOR&channelCode=WEBSITE&utm_content=branchbanking&utm_campaign=website&cta=branch-banking-myzone-banner-second" target="_blank" rel="noopener noreferrer">
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_d50f47d4-1bb8-4719-88db-3397ca474a18.webp"} alt="AxisBank Banner" className="bannerImages d-none d-md-block" width="1349" height="211" title="Flipkart Voucher"/>
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_84280481-c9fa-4f3c-b4fd-09443ce9da7c.webp"} alt="AxisBank Banner" className="bannerImages d-block d-md-none" width="480" height="480"/>
          </a> */}
          
          <a href="https://www.axis.bank.in/accounts/digital-savings-account?cta=branch-locator-banner-digital-savings-account" target="_blank" rel="noopener noreferrer">
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_4f4fe562-4c92-4a87-b064-aadfac726cfa.webp"} alt="AxisBank Banner" className="bannerImages d-none d-md-block" width="1349" height="211" title="Digital Current Account"/>
          <img src={"https://d1hwhsm20o27oj.cloudfront.net/production/axis_930e635b-009e-4eda-9d40-376545091971.webp.jpg"} alt="AxisBank Banner" className="bannerImages d-block d-md-none" width="480" height="480"/>
          </a>
        </Slider>
        </div>


      </div>
    );
  }
}
export default Banner;
